import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TerminosYCondicionesService } from "../../services/terminos.service";
import { SpinnerService } from "../../services/spinner.service";
import { PacienteService } from "../../services/paciente.service";
import { MedicoService } from "../../services/medico.service";
import { UsuarioPanelService } from "../../services/usuario-panel.service";
import { forkJoin } from "rxjs";

@Component({
  selector: "app-leer-tc",
  templateUrl: "./leer-tc.component.html",
  styleUrls: ["./leer-tc.component.scss"],
})
export class LeerTcComponent implements OnInit {

  public init = {
    language: "es",
    menubar: false,
    license_key: "gpl",
    promotion: false,
    plugins: "fullscreen",
    toolbar: "",
    setup: function (editor) {
      editor.on("init", function () {
        editor.execCommand("mceFullScreen");
      });
    },
  };

  public textoTc = "";
  public loading = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly terminosService: TerminosYCondicionesService,
    private readonly spinnerService: SpinnerService,
    private readonly pacienteService: PacienteService,
    private readonly medicoService: MedicoService,
    private readonly usuarioPanelService: UsuarioPanelService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.loading = true;
      this.spinnerService.mostrarSpinner();

      // Convertir el tipo de la URL al tipo real (ej: seccion-paciente -> paciente)
      let tipoUsuario = params.tipo;
      if (tipoUsuario.includes('seccion-')) {
        tipoUsuario = tipoUsuario.replace('seccion-', '');
      }

      // Obtener el usuario autenticado según el tipo
      this.obtenerVersionUsuario(tipoUsuario).then(
        (versionAceptada) => {
          if (versionAceptada !== null && versionAceptada !== undefined) {
            // Mostrar la versión que aceptó el usuario
            this.terminosService.obtenerTerminosPorVersion(tipoUsuario, versionAceptada).subscribe({
              next: (res) => {
                this.textoTc = res.texto;
                this.loading = false;
                this.spinnerService.ocultarSpinner();
              },
              error: () => {
                this.loading = false;
                this.spinnerService.ocultarSpinner();
              }
            });
          } else {
            // Si no tiene versión aceptada, mostrar la última (caso por defecto)
            this.terminosService.obtenerTerminos(tipoUsuario).subscribe({
              next: (res) => {
                this.textoTc = res.texto;
                this.loading = false;
                this.spinnerService.ocultarSpinner();
              },
              error: () => {
                this.loading = false;
                this.spinnerService.ocultarSpinner();
              }
            });
          }
        }
      ).catch(() => {        
        this.terminosService.obtenerTerminos(tipoUsuario).subscribe({
          next: (res) => {
            this.textoTc = res.texto;
            this.loading = false;
            this.spinnerService.ocultarSpinner();
          },
          error: () => {
            this.loading = false;
            this.spinnerService.ocultarSpinner();
          }
        });
      });
    });
  }

  private obtenerVersionUsuario(tipoUsuario: string): Promise<number | null> {
    return new Promise((resolve, reject) => {
      switch (tipoUsuario) {
        case 'paciente':
          this.pacienteService.pacienteLogeado().subscribe({
            next: (data) => {
              resolve(data.paciente?.tc_aceptado);
            },
            error: (err) => reject(err)
          });
          break;
        case 'medico':
          this.medicoService.medicoLogeado().subscribe({
            next: (data) => {
              resolve(data.medico?.tc_aceptado);
            },
            error: (err) => reject(err)
          });
          break;
        case 'panel':
          this.usuarioPanelService.profileUser().subscribe({
            next: (data) => {
              resolve(data?.tc_aceptado);
            },
            error: (err) => reject(err)
          });
          break;
        default:
          reject('Tipo de usuario no válido');
      }
    });
  }
}
